import { ProductCategoryInsert, ProductCategoryDelete, ProductCategoryUpdate, ProductCategoryGetById, ProductCategoryGetList, ProductCategoryGetPageList } from "@/api/productcategory/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    ProductCategoryInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            ProductCategoryInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    ProductCategoryUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ProductCategoryUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    ProductCategoryGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            ProductCategoryGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    ProductCategoryGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ProductCategoryGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    ProductCategoryGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            ProductCategoryGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}